import { SbEditableBlok } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { IconName, ThemeName } from '../../lib/constants'
import { SbLink } from '../../types'
import { NavigationLinkList } from '../Navigation/NavigationLinkList'
import { CTAButton } from '../UI/CTAButton'
import { CustomerStoryCard } from '../UI/CustomerStoryCard/CustomerStoryCard'
import { useI18n } from '../../lib/context/i18n'

export type SidebarItemType = SbEditableBlok & {
  title: string
  subtitle: string
  icon: IconName
  theme: ThemeName
  link: SbLink
}

export const SidebarItem = ({ item }: { item: SidebarItemType }) => {
  const { getTranslatedUrlFromLink } = useI18n()
  switch (item.component) {
    case 'CtaButton':
      return (
        <CTAButton
          label={item.subtitle}
          title={item.title}
          icon={item.icon}
          theme={`theme-${item.theme}` as ThemeName}
          to={getTranslatedUrlFromLink(item.link)}
          href={item.to}
        />
      )

    case 'CustomerStoryCard':
      const url = getTranslatedUrlFromLink(item.link)
      return (
        <CustomerStoryCard
          logo={item.logo.filename}
          alt={item.title}
          theme={`theme-${item.theme}` as ThemeName}
          to={url}
          href={url}
        >
          {item.description}
        </CustomerStoryCard>
      )

    case 'NavigationLinkList':
      return <NavigationLinkList links={item.links} />

    default:
      return null
  }
}
